/**
 * Sentry Configuration
 * Error tracking setup pro produkční monitoring
 */

import { SENTRY_DSN, SENTRY_ENVIRONMENT, ENABLE_ERROR_TRACKING } from './env';

/**
 * Inicializace Sentry (pouze pokud je DSN nastaven)
 */
export const initSentry = () => {
  // Sentry není nainstalován, připravíme strukturu pro budoucí integraci
  if (!ENABLE_ERROR_TRACKING || !SENTRY_DSN) {
    if (process.env.NODE_ENV === 'development') {
      console.log('Sentry is not configured. Error tracking is disabled.');
    }
    return;
  }

  // TODO: Po instalaci @sentry/react:
  /*
  import * as Sentry from "@sentry/react";
  
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: SENTRY_ENVIRONMENT === 'production' ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    
    // Ignorovat některé chyby
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP 'optimizing' proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // Network errors
      'NetworkError',
      'Failed to fetch',
    ],
    
    // Ignorovat některé URL
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Facebook plugins
      /connect\.facebook\.net/i,
      // Other plugins
      /127\.0\.0\.1:4001/i,
    ],
  });
  */
  
  console.log('Sentry initialization would happen here');
};

/**
 * Capture exception do Sentry
 * @param {Error} error - Error objekt
 * @param {Object} context - Dodatečný kontext
 */
export const captureException = (error, context = {}) => {
  if (!ENABLE_ERROR_TRACKING || !SENTRY_DSN) {
    return;
  }

  // TODO: Po instalaci Sentry:
  /*
  if (window.Sentry) {
    window.Sentry.captureException(error, {
      contexts: { custom: context },
      tags: {
        component: context.component || 'unknown',
      },
    });
  }
  */
  
  // Fallback na console v development
  if (process.env.NODE_ENV === 'development') {
    console.error('Sentry captureException (not configured):', error, context);
  }
};

/**
 * Capture message do Sentry
 * @param {string} message - Message
 * @param {string} level - Level (info, warning, error)
 */
export const captureMessage = (message, level = 'info') => {
  if (!ENABLE_ERROR_TRACKING || !SENTRY_DSN) {
    return;
  }

  // TODO: Po instalaci Sentry:
  /*
  if (window.Sentry) {
    window.Sentry.captureMessage(message, level);
  }
  */
  
  if (process.env.NODE_ENV === 'development') {
    console.log(`Sentry captureMessage (not configured) [${level}]:`, message);
  }
};

